var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderLineM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5H4C2.067 11.5 0.5 9.933 0.5 8V0.5H8C9.933 0.5 11.5 2.067 11.5 4V11.5Z",
    stroke: "#FCD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderLineM);
export default __webpack_public_path__ + "static/media/border-line-m.2eb5ba220293d6f9e19344ea401e157b.svg";
export { ForwardRef as ReactComponent };